var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDigitalOcean = function SvgDigitalOcean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 22V18.1219C16.1063 18.1219 19.2927 14.051 17.7165 9.73068C17.1382 8.14316 15.8568 6.8618 14.258 6.28348C9.93763 4.71863 5.86676 7.89369 5.86676 11.9986H2C2 5.4557 8.32743 0.352935 15.1878 2.4961C18.1814 3.43727 20.5741 5.81856 21.5039 8.81219C23.6471 15.6726 18.5443 22 12.0014 22Z",
    fill: "#0080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0128 18.1446H8.146V14.2778H12.0128V18.1446Z",
    fill: "#0080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14613 21.1041H5.18652V18.1445H8.14613V21.1041Z",
    fill: "#0080FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.18647 18.1445H2.70312V15.6611H5.18647V18.1445Z",
    fill: "#0080FF"
  })));
};

export { SvgDigitalOcean as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTIuMDAxNCAyMlYxOC4xMjE5QzE2LjEwNjMgMTguMTIxOSAxOS4yOTI3IDE0LjA1MSAxNy43MTY1IDkuNzMwNjhDMTcuMTM4MiA4LjE0MzE2IDE1Ljg1NjggNi44NjE4IDE0LjI1OCA2LjI4MzQ4QzkuOTM3NjMgNC43MTg2MyA1Ljg2Njc2IDcuODkzNjkgNS44NjY3NiAxMS45OTg2SDJDMiA1LjQ1NTcgOC4zMjc0MyAwLjM1MjkzNSAxNS4xODc4IDIuNDk2MUMxOC4xODE0IDMuNDM3MjcgMjAuNTc0MSA1LjgxODU2IDIxLjUwMzkgOC44MTIxOUMyMy42NDcxIDE1LjY3MjYgMTguNTQ0MyAyMiAxMi4wMDE0IDIyWiIgZmlsbD0iIzAwODBGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjAxMjggMTguMTQ0Nkg4LjE0NlYxNC4yNzc4SDEyLjAxMjhWMTguMTQ0NloiIGZpbGw9IiMwMDgwRkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjE0NjEzIDIxLjEwNDFINS4xODY1MlYxOC4xNDQ1SDguMTQ2MTNWMjEuMTA0MVoiIGZpbGw9IiMwMDgwRkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE4NjQ3IDE4LjE0NDVIMi43MDMxMlYxNS42NjExSDUuMTg2NDdWMTguMTQ0NVoiIGZpbGw9IiMwMDgwRkYiLz4KPC9zdmc+Cg==";